import { ObserveRefreshData } from "../../../../../types/observe";
import "./RemoteAssist.scss";

interface RemoteAssistProps {
  refreshData: ObserveRefreshData | null;
}

const RemoteAssist = ({ refreshData }: RemoteAssistProps) => {
  const rai = refreshData?.rai;
  const isButtonEnabled =
    refreshData?.drive?.monitor_f === "1" &&
    !refreshData?.other_selecting &&
    refreshData?.drive?.drive_mode === 1;

  return (
    <div className="remoteAssistArea">
      <div className="title">遠隔アシスト</div>
      <div className="buttonWrapper">
        <button
          className={`assistBtn ${rai?.assist_enable === "1" ? "active" : ""}`}
          disabled={!isButtonEnabled}
        >
          遠隔
          <br />
          アシスト
        </button>
        <select value={rai?.detour_route ?? ""} disabled onChange={() => {}}>
          <option value="">なし</option>
          <option value="1">ルート1</option>
          <option value="2">ルート2</option>
          <option value="3">ルート3</option>
          <option value="4">ルート4</option>
        </select>
        <button
          className={`hazardBtn ${rai?.cue_hazard_on === "1" ? "active" : ""}`}
          disabled={!isButtonEnabled}
        >
          ハザード
        </button>
      </div>
      <div className="buttonWrapper">
        <button
          className={`forwardBtn ${rai?.cue_forward === "1" ? "active" : ""}`}
          disabled={!isButtonEnabled}
        >
          進行
        </button>
        <button
          className={`slowBtn ${rai?.cue_slow_down === "1" ? "active" : ""}`}
          disabled={!isButtonEnabled}
        >
          徐行
        </button>
        <button
          className={`stopBtn ${rai?.cue_stop === "1" ? "active" : ""}`}
          disabled={!isButtonEnabled}
        >
          停止
        </button>
      </div>
    </div>
  );
};

export default RemoteAssist;
